<script>
    import { page } from '$app/stores';
    import Button from './Button.svelte';
    import HeroPane from './HeroPane.svelte';
    import HeroStars from './HeroStars.svelte';
    import HomeExploreModal from './HomeExploreModal.svelte';
    import PageSection from './PageSection.svelte';
    import { logEvent } from './utils/logs';
    import Prose from './Prose.svelte';

    let className = '';
    export { className as class };

    const hero = $page.data.hero || {};

    let show_explore_modal = false;

    const open_explore_modal = () => {
        logEvent('hero-explore');
        show_explore_modal = true;
    };
</script>

<div
    id="page-hero"
    class="
        relative flex flex-col items-start xl:items-center justify-center overflow-x-clip overflow-y-visible
        pb-8 lg:pb-16
        {className}
    "
>
    <HeroStars />

    <PageSection
        class="
            relative z-10
            pt-8 lg:pt-32 xl:pt-56
        "
    >
        <HeroPane class="hidden xl:flex absolute top-0 bottom-0 left-[780px] 2xl:left-[885px] z-[1]" />
        <Prose xl class="pl-4 max-w-[760px]">
            <h1>{@html hero.title}</h1>
            <p class="lead">
                {@html hero.lead}
            </p>

            <p>
                <Button primary class="not-prose" on:click={open_explore_modal}
                    >{hero.cta}</Button
                >
            </p>
        </Prose>
    </PageSection>
</div>

<HomeExploreModal content={hero.modal || {}} bind:shown={show_explore_modal} />
